module.exports = __webpack_public_path__ + "img/ticket_refund_banner.fefb2196.png";